<template>
  <div class="container">
    <form v-if="!this.is_won" class="form-container" onsubmit="return false" autocomplete="off">
        <label for="word-input">Слово</label>
        <input class="input-word" ref="input_ref" v-model="input_word" type="text" name="word-input">
      <button @click="check_word(input_word)">вгадати</button>
    </form>
    <div class="answer-container">
      <div class="guessed-block">
        <p class="recent-answer"> 
          {{ this.info }} <b>{{ this.recent_word }} {{ this.recent_pos }}</b>
        </p>
        <button @click="try_again()" v-if="this.is_won" class="tryagain">заново</button>
      </div>

        <ul class="answer-list">
          <li class="answer" v-for="(word) in Object.keys(words_sorted)" :key="word">
            {{ word }} {{ words_sorted[word] }}
          </li>
        </ul>
    </div>
  </div>
  
  
</template>

<script>
import axios from 'axios';


export default {
  name: 'App',
  mounted(){
    if(!this.$cookies.get("token")){
      this.$cookies.set("token", crypto.randomUUID(), "12h")
    }
  },
  data() {
    return {
      words: {},
      recent_word : '',
      recent_pos : null,
      input_word : '',
      info: '',
      is_won: false,
    }
  },
  computed: {
    words_sorted() {
      let w_sorted = Object.fromEntries(
        Object.entries(this.words).sort(([, a], [, b]) => a - b)
      );
      return w_sorted
    }
  },
  methods: {
    check_word(){
      if(this.is_won || this.input_word.trim() == '') {
        return;
      }
        axios.post('https://vgadaj-slovo-backend-production.up.railway.app/words',{  "word": this.input_word.trim().toLowerCase() })
        .then(response => {
          this.responseData = response.data;
          this.info = '';
          if (this.responseData == 1){
            this.is_won = true;
            this.info = 'Вітаю, ти вгадав(ла) слово!'
            this.recent_word = '';
            this.recent_pos = null;
            this.words[this.input_word.toLowerCase()] = this.responseData;
          }
          else if(this.responseData > -1){
            this.recent_word = this.input_word.toLowerCase();
            this.recent_pos = this.responseData;
            this.words[this.input_word.toLowerCase()] = this.responseData;
          } else {
            this.info = "Я не знаю слова ";
            this.recent_word = this.input_word.toLowerCase();
            this.recent_pos = null;
          }
          this.input_word = '';
          this.$refs.input_ref.value = '';
        })
        .catch(error => {console.log("Error occured: ", error)});
    },
    try_again(){
      this.is_won = false;
      this.recent_word = '';
      this.recent_pos = null;
      this.input_word = '';
      this.info = '';
      this.words = {}
    }
  },
}
</script>

<style>
* {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
body {
  background-color: rgb(236, 212, 250);
  background: radial-gradient(circle,rgba(242, 223, 247, 1) 0%, rgba(213, 181, 232, 1) 100%);

}
.answer-container {
  max-width: 500px;
  min-width: 300px;
  align-self: center;
}

.answer-list {
  padding: 0;
}
.answer {
  background-color: rgba(217, 162, 224, 0.719);
  border-radius: 15px;
  height: 20px;
  margin: 5px;
  list-style: none;
  padding: 8px 16px;
  box-shadow: inset 0 0 10px 2px rgb(255, 250, 255);
  color: rgb(0, 0, 0);
  border: 1px solid #d99fff;
  transition: all 0.1s ease-out;
}

.answer:hover {
  box-shadow: inset 0 0 10px 3px rgb(255, 250, 255);
  background-color: rgba(218, 128, 230, 0.719);
}

.recent-answer {
  background-color: #bfa2dfb8;
  border-radius: 15px;
  min-height: 20px;
  margin: 0 0 5px;
  list-style: none;
  padding: 8px 16px;
  box-shadow: inset 0 0 10px 2px rgb(255, 250, 255);
  color: rgb(0, 0, 0);
  border: 1px solid #d99fff;
  word-wrap: break-word;
  min-width: 300px;
}

.input-word {
  padding: 8px 5px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
}

.container {
  display: flex;
  flex-direction: column;
  margin-top: 40px;
}

.form-container {
  display: flex;
  align-self: center;
  align-items: center;
  margin-bottom: 20px;
}

.form-container label {
  margin-right: 5px;
}

button {
  margin-left: 5px;
  padding: 5px;
  border: 1px solid rgb(161, 130, 170);
  border-radius: 3px;
  background-color: rgb(250, 214, 255);
  font-size: 14px;
  box-shadow: inset 0 0 7px 2px rgb(255, 192, 255);
}

button:hover {
  cursor: pointer;
  box-shadow: inset 0 0 7px 5px rgb(252, 220, 255);
}

.tryagain {
  align-self: center;
}

h1 {
  text-align: center;
}

.guessed-block {
  display: flex;
  justify-content: space-between;
}

</style>
